/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Popover } from '@festo-ui/react';
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const InfoButtonPopup = function (_a: any) {
  const children = _a.children;
  return React.createElement(
    Popover,
    {
      className: 'fr-info-button',
      position: 'right',
      popoverContent: children,
      fallbackPositions: ['bottom', 'left', 'top'],
    },
    React.createElement('span', { className: 'facet-field__inline-icon fwe-icon fwe-icon-status-info' }),
  );
};
export default InfoButtonPopup;
